import { useState } from 'react';
import ENDPOINT from '../constants/endpoints';
import ResponseErrorDialog from '../scenes/Dialog/components/ResponseErrorDialog';
import useApi from './useApi';

export const useNetworkActions = () => {
  const api = useApi();
  const [isPending, setPending] = useState(false);

  const request = (endpoint, params) => {
    return new Promise(resolve => {
      setPending(true);
      api.post(endpoint, params, {
        handleError: response => {
          setPending(false);
          ResponseErrorDialog({ response });
        },
        handleSuccess: () => {
          setPending(false);
          resolve();
        },
      });
    });
  };

  const connect = id => request(ENDPOINT.ACTION.NETWORK.CONNECT, { id });

  const disconnect = id => request(ENDPOINT.ACTION.NETWORK.DISCONNECT, { id });

  const reject = token => request(ENDPOINT.ACTION.NETWORK.REJECT, { token });

  const accept = token => request(ENDPOINT.ACTION.NETWORK.ACCEPT, { token });

  return [
    isPending,
    {
      connect,
      disconnect,
      reject,
      accept,
    },
  ];
};
